<template>
  <div>
    <button
      class="btn btn-danger btn-icon"
      @click="$modal.show('import_products')"
    >
      Импорт данных
    </button>
    <modal name="import_products">
      <card>
        <h4>Загрузка файлов EXCEL.</h4>
        <h6>1. Выберите файл XLSX</h6>
        <h6>2. Ожидайте загрузку файла на сервер</h6>
        <h6>
          3. После загрузки документа ожидайте 1-5 минут. Чтобы избежать больших
          нагрузок на сервер, данные записываются блоками.
        </h6>
        <zip-upload @input="upload" />
      </card>
    </modal>
  </div>
</template>
<script>
export default {
  name: "filter",
  components: {},
  methods: {
    upload(val) {
      let form = new FormData();

      form.append("");
    },
  },
  data() {
    return {};
  },
};
</script>
<style>
</style>
